import { supabase } from '../supabase/client';

// Sicherheits-Allowlist: nur diese MIME-Typen duerfen einem Blob zugewiesen werden, der
// spaeter in <img>/<iframe> gerendert oder top-level geoeffnet wird. So kann ein angreifer-
// kontrollierter Anhang-Content-Type (z. B. text/html, image/svg+xml aus einer fremden Mail)
// NIE als solcher getypt und same-origin ausgefuehrt werden (XSS-Schutz).
export const SICHERE_ANHANG_MIME = new Set([
  'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'application/pdf',
]);

// Holt die Bytes eines E-Mail-Anhangs (No-Bucket: aus dem Postfach via Edge Function) als Blob.
// Der Blob-Typ wird auf die Allowlist beschraenkt; alles andere -> application/octet-stream (nur Download).
export async function ladeAnhangBlob(anhangId: string, mimeType?: string | null): Promise<Blob> {
  const { data, error } = await supabase.functions.invoke('anhang-datei', { body: { anhangId } });
  if (error) {
    let msg = error.message || 'Anhang konnte nicht geladen werden';
    const resp: any = (error as any).context;
    if (resp && typeof resp.json === 'function') {
      try { const b = await resp.json(); if (b?.error) msg = b.error; } catch { /* ignore */ }
    }
    throw new Error(msg);
  }
  let roh: Blob;
  if (data instanceof Blob) roh = data;
  else if (data instanceof ArrayBuffer) roh = new Blob([data]);
  else roh = new Blob([data as BlobPart]);
  const typ = (mimeType || '').toLowerCase().split(';')[0].trim();
  const sicher = SICHERE_ANHANG_MIME.has(typ) ? typ : 'application/octet-stream';
  return new Blob([await roh.arrayBuffer()], { type: sicher });
}

/**
 * #519: Typ für die Vorschau. Unbestimmte Typen (leer/octet-stream) werden NUR für .pdf/.jpg/.jpeg/.png
 * anhand der Endung eingeordnet – der Blob wird dann hart auf diesen harmlosen Typ gesetzt (Allowlist),
 * nie auf HTML/SVG. Alle anderen Werte bleiben unverändert.
 */
export function vorschauTyp(dateityp: string | null | undefined, dateiname: string | null | undefined): string | null {
  const typ = (dateityp || '').split(';')[0].trim().toLowerCase();
  if (typ && typ !== 'application/octet-stream') return dateityp ?? null;
  const ext = (dateiname || '').toLowerCase().split('.').pop() ?? '';
  if (ext === 'pdf') return 'application/pdf';
  if (ext === 'jpg' || ext === 'jpeg') return 'image/jpeg';
  if (ext === 'png') return 'image/png';
  return dateityp ?? null;
}
